import { useContext } from "react";
import GlobalContext from "../../context/Global";
import { getEnvVariables } from "../helpers";

export function useEnv() {
	const { isPreviewMode } = useContext(GlobalContext);

	return getEnvVariables(isPreviewMode);
}
